import { Trigger } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { FormFieldState } from '@/shared/ui/form/types';
import { Icon } from '@/shared/ui/icon';
import './dropdown.scss';

type Props = ComponentPropsWithRef<typeof Trigger> & {
    state?: FormFieldState;
};

export const DropdownTrigger = ({ children, className, state, ...props }: Props) => (
    <Trigger
        data-testid="dropdown-trigger"
        data-state={state}
        className={cn('dropdown__trigger', state === 'error' && 'dropdown__trigger--error', className)}
        {...props}
    >
        {children}
        <Icon name="chevron-right" className="dropdown__trigger-icon" />
    </Trigger>
);
